module.exports = __webpack_public_path__ + "static/media/Candino.cf56cc4c.png";